import { z } from 'zod';

export const ImportDataDtoSchema = z.record(z.string(), z.unknown());

export const ImportDataListDtoSchema = z.object({
    data: z.array(ImportDataDtoSchema),
});
